import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * This component automatically scrolls the window to the top whenever the route changes.
 * It uses the useLocation hook from react-router-dom to detect route changes.
 * 
 * Usage:
 * Place this component inside BrowserRouter but outside Routes in your app's routing setup.
 */
const ScrollToTop = () => {
  // Get the current location object from react-router
  const { pathname } = useLocation();

  // Effect that runs whenever the pathname changes
  useEffect(() => {
    // Scroll to top of the window
    window.scrollTo(0, 0);
  }, [pathname]); // Only re-run the effect when pathname changes

  // This component doesn't render anything
  return null;
};

export default ScrollToTop; 